import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

import {changeRegistrationState, createRegistration, getRegistration} from '../../../Redux/actions/registrationAction'
import {resetRegistration, saveRegistration} from '../../../Redux/actions/registrationAction'
import {changeVisibleState} from '../../../Redux/actions'
import {addDiscountMargin, changePriceState} from '../../../Redux/actions/priceAction'
import {changeBackState} from '../../../Redux/actions/warehouseBackActions'
import {checkObject} from '../../general/utils'
import {changeRemainState} from '../../../Redux/actions/remainAction'

import ChooseDate from '../../general/calandar/ChooseDate'
import BottomButtons from '../../general/BottomButtons'
import LabelInput from '../../general/LabelInput'
import LabelArea from '../../general/LableArea'
import SetClient from '../../general/SetClient'
import AddParts from './AddParts'
import TableRegistrationPart from './TableRegistrationPart'
import SelectFromList from '../../general/SelectFromList'
import WarningChangeWarehouse from './WarningChangeWarehouse'
import {EditorID, Modal} from "../../../data/data";


const RegistrationEditor = (props) => {

    const [messageWarning, setMessageWarning] = useState(false)
    const [warehouse, setWarehouse] = useState({})

    const handleClose = () => {
        props.changeVisibleState({
            isRightModalOpen: false,
            modalType: '',
            inputRegistrationLabelChecked: true,
            inputRegistrationClientChecked: true,
            inputRegistrationWarehouseChecked: true,
            inputRegistrationPartChecked: true
        })
        props.resetRegistration()
        props.changeVisibleState({statusRegistrationEditor: false})
    }

    useEffect(() => {
        props.changePriceState({showDeleted: false, filter_type: 2})
        props.addDiscountMargin()
    }, [])


    const clickHandle = (event) => {
        const ids = event.composedPath().map(el => el.id);
        if (
            !ids.includes(EditorID.REGISTRATION)
            && !ids.includes(EditorID.REGISTRATION_PART)
            && !ids.includes(EditorID.BACK)
        ) {
            handleClose();
        }
    }

    useEffect(() => {
        window.addEventListener('click', clickHandle)
        return () => {
            window.removeEventListener('click', clickHandle)
        }
    })

    const handleCreate = () => {
        if (createConditions) {
            props.createRegistration()
        } else {
            checkAllField()
        }
    }

    const handleSave = () => {
        if (saveConditions) {
            props.saveRegistration()
        } else {
            checkAllField()
        }
    }

    const saveConditions = [
        props.registration.number,
        checkObject(props.registration.warehouse),
        checkObject(props.registration.client),
        props.registration.parts.length
    ].every(Boolean);

    const createConditions = [
        props.registration.number,
        checkObject(props.registration.warehouse),
        (checkObject(props.registration.client) || props.registration.inventory_id),
        props.registration.parts.length,
    ].every(Boolean);

    const checkAllField = () => {
        if (!props.registration.number) {
            props.changeVisibleState({inputRegistrationLabelChecked: false})
        }
        if (!checkObject(props.registration.warehouse)) {
            props.changeVisibleState({inputRegistrationWarehouseChecked: false})
        }
        if (!checkObject(props.registration.client)) {
            props.changeVisibleState({inputRegistrationClientChecked: false})
        }
        if (!props.registration.parts.length) {
            props.changeVisibleState({inputRegistrationPartChecked: false})
        }
    }

    const handleChange = (warehouse) => {
        if (props.registration.parts.length) {
            setWarehouse(warehouse)
            setMessageWarning(true)
        } else {
            props.changeRegistrationState({warehouse})
        }
    }

    const handleBack = () => {
        props.changeVisibleState({isCentralModalOpen: true, modalCentralType: Modal.Type.BACK})
        props.changeBackState({
            client: props.registration.client,
            registration: {
                id: props.registration.edit,
                label: props.registration.label
            }
        })
        props.changeRemainState({filter_registration_id: props.registration.edit})
    }

    const canDoBack = props.registration.inventory_id || !props.registration.edit || !props.permissions.includes('create_refund_to_supplier')

    return (
        <div className='modal__box-right' id={EditorID.REGISTRATION}>
                <h4>
                    {props.registration.edit ? `Оприходование ${props.registration.label}` : ' Новое оприходование'}
                </h4>
                <div className='modal__body-right'>
                    <SetClient
                        id='regClient'
                        title='Имя поставщика'
                        setClient={client => props.changeRegistrationState({client})}
                        client={props.registration.client}
                        checkedFlag='inputRegistrationClientChecked'
                        redStar={true}
                        disabled={!!props.registration.edit}
                        invisible={props.registration.inventory_id}
                    />
                    <div className='two-buttons'>
                        <LabelInput
                            className='w220'
                            title='Накладная №'
                            onChange={event => props.changeRegistrationState({number: event.target.value})}
                            value={props.registration.number}
                            checkedFlag='inputRegistrationLabelChecked'
                            redStar={true}
                        />
                        <div className='mb5'>от</div>
                        <ChooseDate
                            title='Дата'
                            func={date => props.changeRegistrationState({custom_created_at: parseInt(date / 1000)})}
                            current_date={props.registration.custom_created_at * 1000}
                            disabled={!!props.registration.edit}
                            time={false}
                        />
                    </div>
                    <SelectFromList
                        className='w220'
                        title='Склад'
                        list={props.warehouses}
                        setElement={warehouse => handleChange( warehouse)}
                        current_object={props.registration.warehouse}
                        checkedFlag='inputRegistrationWarehouseChecked'
                        noChoosed='Выберете склад'
                        disabled={!!props.registration.edit || !!props.registration.inventory_id}
                    />
                    <AddParts invisible={!!props.registration.edit || !!props.registration.inventory_id}/>
                    {props.view.inputRegistrationPartChecked ? null : <div className='errorMassageInput'>Добавьте хотябы одну запчасть</div>}
                    <TableRegistrationPart/>
                    <LabelArea
                        title='Комментарий'
                        onChange={event => props.changeRegistrationState({description: event.target.value})}
                        value={props.registration.description}
                    />
                </div>

                <BottomButtons
                    edit={props.registration.edit}
                    create={handleCreate}
                    save={handleSave}
                    close={handleClose}
                    extraButton={canDoBack ? null : handleBack}
                    extraTitle='Сделать возврат'
                />
                {messageWarning ?
                    <WarningChangeWarehouse
                        setMessageWarning={setMessageWarning}
                        warehouse={warehouse}
                    /> : null
                }
            </div>
    )
}

const mapStateToProps = (state) => ({
    registration: state.registration,
    view: state.view,
    warehouses: state.warehouse.warehouses,
    permissions: state.data.user.role.permissions,
})

const mapDispatchToProps = {
    changeVisibleState,
    changeRegistrationState,
    createRegistration,
    saveRegistration,
    resetRegistration,
    addDiscountMargin,
    changePriceState,
    getRegistration,
    changeBackState,
    changeRemainState
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationEditor)
